<template>
    <div class="pp-time-picker">
        <template v-for="(item, index) in columns">
            <div :key="index"
                class="pp-date-time-picker__column"
                :data-time="item"
                @scroll="scroll">
                <div v-for="(option, index2) in options[item]" :key="index2" 
                    class="pp-date-time-picker__option">
                    {{option}}
                </div>
            </div>
        </template>
    </div>
</template>

<script>
import * as config from './config.js'
import { Throttle } from '../../../src/util/throttle.js'
export default {
    data: function() {
        return {
            height: 0,
            columns: ['hours', 'minutes', 'seconds'],
            options: {
                hours: config.Hours,
                minutes: config.Minutes,
                seconds: config.Seconds,
            },
            currentValue: {
                hours: config.Hours[0], minutes: config.Minutes[0], seconds: config.Seconds[0],
            },
        };
    },
    inject: {
        DateTimePicker: { default: '' },
    },
    watch: {
        'DateTimePicker.showPopup': function(n) {
            if(n) {
                !this.height && this.getHeight()

                let date = this.DateTimePicker.dateTime;
                
                this.columns.forEach(key=> {
                    this.setScrollTo(key, date[key])
                })
            }
        },
    },
    mounted: function() {
        this.getHeight()
        this.throttleGetScrollTo = Throttle(25, this.getScrollTo)
    },
    methods: {
        scroll: function({ target }) {
            // this.throttleGetScrollTo(target)
            this.getScrollTo(target)
        },

        getScrollTo: function(el) {
            let last = el.scrollTop;
            let timer = null;

            timer = setTimeout(()=> {
                let now = el.scrollTop;

                if(now === last) {
                    !this.height && this.getHeight()

                    let step = Math.round(now / this.height);
                    let key = el.dataset.time;
                    let index = Math.round((el.scrollTop) / this.height);

                    el.scrollTop = step * this.height;
                    this.$set(this.currentValue, key, this.options[key][index])
                    this.DateTimePicker.update(this.currentValue)
                }
            }, 50)
        },

        setScrollTo: function(key, value) {
            this.getHeight()

            let el = this.$el.querySelector(`[data-time=${key}]`);
            let index = this.options[key].findIndex(v=> v == value);

            el.scrollTop = index === -1 ? 0 : index * this.height
        },

        getHeight: function() {
            this.height = this.$el.querySelector('.pp-date-time-picker__option').getBoundingClientRect().height
        },
    },
}
</script>

<style>

</style>
